import {makeAutoObservable} from "mobx";
import {inject, injectable} from "inversify";
import {get} from "lodash";
import {ViewController} from "data/types/structure";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IPlayerOdds} from "data/providers/api/tournament.provider";
import type {ICountryStore} from "data/stores/country/country.store";
import {getOddsTransformValueWith} from "data/utils/helper";

export interface IPoolRowController extends ViewController {
	readonly i18n: ILocalizationStore;

	getOddsValue: (value: IPlayerOdds | null) => string;
}

@injectable()
export class PoolRowController implements IPoolRowController {
	private get isShowOdds() {
		return this._countryStore.isShowOdds;
	}

	constructor(
		@inject(Bindings.CountryStore) private _countryStore: ICountryStore,
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore
	) {
		makeAutoObservable(this);
	}

	getOddsValue = (value: IPlayerOdds | null) => {
		if (!this.isShowOdds || !value) {
			return "-";
		}

		return getOddsTransformValueWith(get(value, this._countryStore.country));
	};
}
